export default class PageTop {
  constructor() {
    this.$target = document.querySelector('[data-page-top]');
    this.$footerEnd = document.querySelector('[data-footer-end]');
    if (!this.$target && !this.$footerEnd) return;
    this.$trigger = document.querySelector('[data-page-top-trigger]');
    this.init();
  }

  init() {
    this.setup();
    this.onScroll();
  }

  setup() {
    gsap.set(this.$target, { autoAlpha: 0, yPercent: 75 })
  }

  onScroll() {
    window.addEventListener('scroll', () => {
      if (this.$trigger) {
        if (window.pageYOffset > this.$trigger.offsetTop) {
          this.show();
        } else {
          this.hide();
        }
      } else {
        if (window.pageYOffset > 0) {
          this.show();
        } else {
          this.hide();
        }
      }

      if (this.isElementInViewport(this.$footerEnd)) {
        this.setElementPosition('absolute');
      } else {
        this.setElementPosition('fixed');
      }
    });
  }

  show() {
    gsap.to(this.$target, {
      autoAlpha: 1,
      yPercent: 0,
      duration: 0.6,
      ease: 'power2.out',
    })
  }

  hide() {
    gsap.to(this.$target, {
      autoAlpha: 0,
      yPercent: 75,
      duration: 0.6,
      ease: 'power2.out',
    })
  }

  setElementPosition(position) {
    this.$target.style.position = position;
  }

  isElementInViewport(element) {
    const rect = element.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }
}